import { render, staticRenderFns } from "./regTypeFieldTabItem.vue?vue&type=template&id=438aeee2"
import script from "./regTypeFieldTabItem.vue?vue&type=script&lang=js"
export * from "./regTypeFieldTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports